// endpoints.js
import api from "@/api/api";


export const apiFinalizeReservation = async (data) => {
    try {
        const response = await api.post('/finalize_reservation', data);
        return response.data;
    } catch (error) {
        console.error('There was an issue finalizing the reservation:', error);
        throw error;
    }
};

export const apiCreateReservation = async (newReservation) => {
    try {
        const response = await api.post('reservations/', newReservation);
        return response.data;
    } catch (error) {
        console.error('There was an error creating the reservation:', error);
        throw error;
    }
};

export const apiUpdateReservations = async (updatedReservations) => {
    try {
        const response = await api.post('update_reservations/', updatedReservations);
        return response.data;
    } catch (error) {
        console.error('Failed to update reservations:', error);
        throw error;
    }
};

export const apiUpdateReservationTentId = async (reservationUpdate) => {
    try {
        const response = await api.post('update_reservation_tent_id/', reservationUpdate);
        return response.data;
    } catch (error) {
        console.error('There was an error updating the reservation:', error);
        throw error;
    }
};

export const apiDeleteReservation = async (reservationToDelete) => {
    try {
        const response = await api.delete('reservations/', { data: reservationToDelete });
        return response.data;
    } catch (error) {
        console.error('There was an error deleting the reservation:', error);
        throw error;
    }
};

export const apiCreatePlace = async (newPlace) => {
    try {
        const response = await api.post('places/', newPlace);
        return response.data;
    } catch (error) {
        console.error('There was an error creating the place:', error);
    }
};

export const apiDeletePlace = async (placeToDelete) => {
    try {
        const response = await api.delete('places/', { data: placeToDelete });
        return response.data;
    } catch (error) {
        console.error('There was an error deleting the place:', error);
        throw error;
    }
};
